/* Nobi website prototype v3.0 — noise-chart.js (extracted from index.html, 8 Oct 2026) */
  // C7: noise chart plays when in view; Replay restarts it
  (function () {
    const n = document.getElementById('noise');
    if (!n) return;
    n.addEventListener('inview', () => n.classList.add('play'));
    const restart = () => { n.classList.remove('play'); void n.offsetWidth; n.classList.add('play'); };
    const timing = ['--a0', '--dur', '--rise0', '--rise', '--b0'];
    const sound = document.getElementById('sc-listen');
    document.getElementById('noise-replay').addEventListener('click', () => {
      // With sound on, the sound restarts the chart in step (nobi:cocoon-play below); without, the chart plays at its own pace.
      if (sound && sound.getAttribute('aria-pressed') === 'true') { document.dispatchEvent(new CustomEvent('nobi:cocoon-replay')); return; }
      timing.forEach(v => n.style.removeProperty(v)); restart();
    });
    // "Hear the difference" (v3.js) plays the chart in step with the sound (17 Oct call, Isabelle). len = length of one
    // night in seconds. The corridor clip has the door at 0.4 s, footsteps 1.7-4.9 s, voices 4.7-7.3 s and a cart
    // loudest at 7.6 s; a night of len + 0.15 s that starts 0.65 s early puts the chart's four markers on those sounds.
    document.addEventListener('nobi:cocoon-play', (e) => {
      const len = e.detail.len, set = (k, v) => n.style.setProperty(k, `${v.toFixed(2)}s`);
      set('--a0', 0.1 - 0.65); set('--dur', len + 0.15);
      set('--rise0', len + 0.4); set('--rise', 2.5);
      set('--b0', len + 3.4 - 0.65);
      restart();
      const r = n.getBoundingClientRect();
      if (r.top < 0 || r.bottom > innerHeight) {
        const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
        n.closest('.noise-card').scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
      }
    });
  })();
